<template>
<div id="finish">
    <navbar id="nav">
    </navbar>
    <div class="mx-5 my-3 mx-auto" style="width:50%">
        <h3>End of Study</h3>

        <p class="m-5">
            Thank you for getting to the end of the study!
        </p>
        <p class="m-5">
            Your completion code is: <code><b>{{completion_code}}</b></code>.
        </p>
        <p class="m-5">
            Copy the completion code and paste on the Mturk HIT page.
            Your HIT will be reviewed within 7 days.
        </p>
        <div class="card p-3">
          <h5>Debriefing – What the Study is About</h5>
      <p>
        In this study you learned about the relationships between variables,
        for example that some medicine might increase or decrease your back pain
        level or your headache level. In general, causal learning can be very
        difficult because the relationships are ‘noisy’ – the medicine might
        not always works for you. In addition, causal learning can be difficult because
        often you need to track the cause and effect day by day. For example,
        when learning if the medicine
        actually influences your pain level in your real life, you might
        try this medicine over a period of a couple weeks. We are trying
        to learn how well people are able to learn these cause-effect
        relations, and how good their memories of their experiences are.
      </p>
        </div>
    </div>
</div>
</template>
<style scoped>
p{
  text-align: left;
}
.card{
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}
</style>
<script>
import axios from 'axios';
import Nav from '../Other/Nav.vue';

export default {
  name: 'Finish',
  components: {
    navbar: Nav,
  },
  data() {
    return {
      userID: null,
      completion_code: null,
    };
  },
  methods: {
    getCode(userID) {
      const path = `${this.$hostname}/get-code/${userID}`;
      axios
        .get(path)
        .then((res) => {
          console.log(res.data.account_progress);
          if (!res.data.isLoggedIn) {
            this.$router.push({ name: 'Login' });
          } else if (res.data.account_progress === 'ExitQuestion') {
            this.$router.push({ name: 'ExitQuestion' });
          } else if (res.data.account_progress !== 'Finish') {
            this.$router.push({ name: 'Task' });
          } else {
            this.completion_code = res.data.completion_code;
          }
        })
        .catch((error) => {
          console.log(error);
          this.message = 'Error';
          this.showMessage = true;
        });
    },
  },
  created() {
    this.userID = localStorage.userID;
    this.getCode(this.userID);
  },
};
</script>
